import { WrappedCardFrame } from "./WrappedCardFrame";
import { BudgetsSavingsCard } from "./BudgetsSavingsCard";
import { MonthSummaryCard } from "./MonthSummaryCard";
import { NextFocusCard } from "./NextFocusCard";
import { RecurringPatternCard } from "./RecurringPatternCard";
import { TopCategoriesCard } from "./TopCategoriesCard";
import type { WrappedCard as WrappedCardData } from "../types";

interface WrappedCardProps {
  card: WrappedCardData;
}

export const WrappedCard = ({ card }: WrappedCardProps) => {
  if (card.data == null) return <WrappedCardFrame title={card.title} body={card.body} />;

  switch (card.type) {
    case "month_summary":
      return <MonthSummaryCard card={card} />;
    case "top_categories":
      return <TopCategoriesCard card={card} />;
    case "recurring_pattern":
      return <RecurringPatternCard card={card} />;
    case "budgets_savings":
      return <BudgetsSavingsCard card={card} />;
    case "next_focus":
      return <NextFocusCard card={card} />;
    default:
      return <WrappedCardFrame title={card.title} body={card.body} />;
  }
};
